import script from "./customerSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./customerSearch.vue?vue&type=script&setup=true&lang=js"

import "./customerSearch.vue?vue&type=style&index=0&id=4520eaed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4520eaed"]])

export default __exports__